import React from 'react';
import { ProductCard } from '../shared/ProductCard';
interface FeaturedProductsProps {
  onNavigate: (page: 'product') => void;
}
export function FeaturedProducts({
  onNavigate
}: FeaturedProductsProps) {
  const products = [{
    name: 'Royal Canin Medium Adult Dry Dog Food 15kg',
    price: 109.99,
    category: 'Dogs',
    badge: 'Best Seller',
    badgeType: 'blue' as const,
    memberPrice: 99.99,
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Kong Classic Dog Toy Large',
    price: 29.99,
    category: 'Dogs',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Hills Science Diet Puppy 12kg',
    price: 94.99,
    category: 'Dogs',
    badge: 'Staff Pick',
    badgeType: 'warm' as const,
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Black Hawk Grain Free Cat Food 8kg',
    price: 79.99,
    category: 'Cats',
    imageColor: 'blue' as const,
    iconType: 'cat' as const
  }, {
    name: 'Seasol Liquid Fertiliser 2L',
    price: 24.95,
    category: 'Garden',
    badge: 'Popular',
    badgeType: 'green' as const,
    imageColor: 'green' as const,
    iconType: 'garden' as const
  }, {
    name: 'Zodiac Pool Chlorine 10kg',
    price: 89.99,
    category: 'Pools',
    imageColor: 'blue' as const,
    iconType: 'pool' as const
  }];
  return <section className="section-padding bg-warm-50" data-id="element-124">
      <div className="container-wide" data-id="element-125">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4" data-id="element-126">
          <div className="max-w-2xl" data-id="element-127">
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-2" data-id="element-128">
              Popular Right Now
            </h2>
            <p className="text-lg text-gray-600" data-id="element-129">
              Top-rated essentials loved by WA locals.
            </p>
          </div>
        </div>

        {/* Horizontal scrollable row */}
        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 sm:mx-0 sm:px-0 gap-6 snap-x snap-mandatory scrollbar-hide" data-id="element-130">
          {products.map((product, index) => <div key={index} className="min-w-[280px] max-w-[280px] snap-start" data-id="element-131">
              <ProductCard {...product} onNavigate={onNavigate} data-id="element-132" />
            </div>)}

          {/* View All Card */}
          <div className="min-w-[280px] max-w-[280px] snap-start flex items-center justify-center" data-id="element-133">
            <button onClick={() => onNavigate('product')} className="flex flex-col items-center justify-center gap-4 text-brand-blue hover:text-brand-blue-700 transition-colors group p-8 active:scale-95" data-id="element-134">
              <div className="w-16 h-16 rounded-full bg-brand-blue-50 flex items-center justify-center group-hover:bg-brand-blue-100 transition-colors shadow-sm" data-id="element-135">
                <span className="text-2xl transform group-hover:translate-x-1 transition-transform" data-id="element-136">
                  →
                </span>
              </div>
              <span className="font-heading font-bold text-lg" data-id="element-137">
                Shop All Products
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>;
}